var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState } from 'react';
import { genId, wrapEvent, isFunctionalComponent } from '../../utils';
import { Box, Flex } from '../Box';
import { Portal } from '../Portal';
import { useTooltip } from './hooks/useTooltip';
export var buildTooltipContentLss = function (colorScheme) { return ({
    maxWidth: '280px',
    color: colorScheme === 'light'
        ? 'primary500'
        : colorScheme === 'error'
            ? 'danger500'
            : 'white',
    bg: colorScheme === 'light' || colorScheme === 'error' ? 'white' : 'primary500',
    borderRadius: 'md',
    pointerEvents: 'none',
    alignItems: 'center',
    px: 'md',
    py: 'sm',
    boxShadow: 'sm'
}); };
export var Tooltip = function (_a) {
    var children = _a.children, title = _a.title, id = _a.id, _b = _a.placement, placement = _b === void 0 ? 'top' : _b, _c = _a.delay, delay = _c === void 0 ? 0 : _c, _d = _a.colorScheme, colorScheme = _d === void 0 ? 'dark' : _d, lss = _a.lss, _e = _a.isDisabled, isDisabled = _e === void 0 ? false : _e, _f = _a.shouldRecalculatePosition, shouldRecalculatePosition = _f === void 0 ? false : _f, _g = _a.enforceRefWrapper, enforceRefWrapper = _g === void 0 ? false : _g, _h = _a.refWrapperLss, refWrapperLss = _h === void 0 ? {} : _h;
    var _j, _k;
    var _l = __read(useState(false), 2), isOpen = _l[0], setOpen = _l[1];
    var defaultTriggerRef = useRef(null);
    var contentRef = useRef(null);
    var childrenElement = React.Children.only(children);
    var isForwardRef = ((_k = (_j = childrenElement === null || childrenElement === void 0 ? void 0 : childrenElement.type) === null || _j === void 0 ? void 0 : _j.render) === null || _k === void 0 ? void 0 : _k.name) === 'forwardRef';
    var canReceiveRef = !isFunctionalComponent(childrenElement) || isForwardRef;
    var _m = useTooltip({
        shouldRecalculatePosition: shouldRecalculatePosition,
        referenceElement: defaultTriggerRef.current,
        popperElement: contentRef.current,
        placement: placement
    }), styles = _m.styles, attributes = _m.attributes;
    if (!title)
        return null;
    var generatedId = id || genId('tooltip');
    var childrenProps = __assign(__assign({}, childrenElement.props), { ref: canReceiveRef && !enforceRefWrapper
            ? defaultTriggerRef
            : childrenElement.props.ref, onMouseOver: wrapEvent(childrenElement.props.onMouseOver, function () { return !isDisabled && setOpen(true); }), onTouchStart: wrapEvent(childrenElement.props.onTouchStart, function () { return !isDisabled && setOpen(true); }), onMouseLeave: wrapEvent(childrenElement.props.onMouseLeave, function () {
            delay ? setTimeout(function () { return setOpen(false); }, delay) : setOpen(false);
        }), onTouchEnd: wrapEvent(childrenElement.props.onTouchEnd, function () {
            delay ? setTimeout(function () { return setOpen(false); }, delay) : setOpen(false);
        }), 'aria-describedby': isOpen ? generatedId : undefined });
    var ClonedChildComponent = React.cloneElement(childrenElement, childrenProps);
    return (React.createElement(React.Fragment, null,
        enforceRefWrapper ? (React.createElement(Box, { lss: __assign({ display: 'inline-block' }, refWrapperLss), ref: defaultTriggerRef }, ClonedChildComponent)) : (ClonedChildComponent),
        React.createElement(Portal, null,
            React.createElement(Box, __assign({ ref: contentRef, style: styles.popper, id: generatedId }, attributes.popper, { lss: { zIndex: 'tooltip' } }), isOpen && (React.createElement(Flex, { lss: __assign(__assign({}, buildTooltipContentLss(colorScheme)), lss) }, title))))));
};
//# sourceMappingURL=Tooltip.js.map